import { useAppSelector } from '@hooks/app/redux';
import React from 'react';
import { useQueryClient } from 'react-query';
import { ACTION_NAMES } from './pendingActions.utils';

function usePendingActionsRefresher() {
  const client = useQueryClient();
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  const refetch = React.useCallback(
    (keys: (keyof typeof ACTION_NAMES)[]) => {
      return Promise.allSettled(
        keys.map((key) =>
          client.refetchQueries({
            active: true,
            exact: false,
            queryKey: [ACTION_NAMES[key], providerId],
          }),
        ),
      );
    },
    [client, providerId],
  );

  return { refetch };
}

export default usePendingActionsRefresher;
